$(document).ready(function () {
    var menuBar = $('.menu-bar');
    $('.mobile-menu-trigger').click(function(){
        $(menuBar).toggleClass('open');
    })

    $('.mobile-menu-back-item').click(function(e) {
        e.stopPropagation();
        let mm = $(this).closest('.mega-menu');
        mm.removeClass('open');
        mm.siblings('.menu-bar-link-parent').removeClass('opened');
    })


    var bodyWidth = $('body').width();
    if(bodyWidth < 1023) {
        $('.menu-bar-link-parent').on('click', (event) => {
            event.preventDefault();
            if($(this).hasClass('opened')) {
                $(this).toggleClass('opened');
                $(this).siblings('.mega-menu').toggleClass('open')

            } else {
                $(this).siblings('.mega-menu').addClass('open');
                $(this).addClass('opened')
            }
        })
    }


    $('.menu-bar-link-parent').hover(function(){
        $(this).siblings('.mega-menu').toggleClass('open');
        $(this).toggleClass('opened')
    })

    if(bodyWidth > 1023) {
        $('.mega-menu').hover(function(){
            $(this).toggleClass('open');
            $(this).siblings('.menu-bar-link-parent').toggleClass('opened')
        })
    }

    $('.mobile-menu-trigger').click(function(){
        $(this).toggleClass('opened');

        if ($(this).hasClass('opened')) {
            $(this).attr('zoneid', 'menu-programmi_mobile-icon_close');
        }
        else {
            $(this).attr('zoneid', 'menu-programmi_mobile-icon_open');
        }
    });

    /*
        Menu di navigazione interna delle pagine dei titoli è sticky rispetto al
        menu primario
    */

    let internalMenu = $('.title-navigation');

    if (internalMenu.length) {
        let initial_top = internalMenu.offset().top;

        $(window).on('scroll', function () {
            let wscoll = $(window).scrollTop();
            internalMenu.toggleClass('sticky', wscoll >= initial_top);
        });
    }

    /*
        Scrolling attivato dal menu di navigazione interna
    */

    $('.smooth-scroll').click((e) => {
        e.preventDefault();
        let destination = $(e.currentTarget).attr('href');
        let offset = 70 * 2;

        /*
            Problema: il fatto che il menu di navigazione interna sia sticky o
            meno impatta sull'offset verticale dell'elemento presso cui
            scrollare. Qui assumo che al termine dell'operazione sarò sempre in
            uno stato in cui il menu è sticky, e pertanto devo aggiustare i
            conti di conseguenza
        */
        if (internalMenu.length) {
            if (internalMenu.hasClass('sticky') == false) {
                offset = 70 * 3;
            }
        }

        window.scroll({
            top: $(destination).offset().top - offset,
            left: 0,
            behavior: 'smooth'
        });
    });
})
